module.exports = __webpack_public_path__ + "static/media/bus4.835e7858.jpg";